<template>
    <div class="backlog-summary-wrapper">
        <MetricCard
            title="Total Backlog"
            :value="localOpenTotal.value"
            :change-text="localOpenTotal.changeText"
            :has-change="localOpenTotal.hasChange"
            :is-positive="localOpenTotal.isPositive"
            :is-good-change="localOpenTotal.isGoodChange"
        />

        <MetricCard
            title="Open at Risk"
            :value="localOpenAtRisk.value"
            :change-text="localOpenAtRisk.changeText"
            :has-change="localOpenTotal.hasChange"
            :is-positive="localOpenAtRisk.isPositive"
            :is-good-change="localOpenAtRisk.isGoodChange"
        />

        <MetricCard
            title="Open Breached"
            :value="localOpenBreached.value"
            :change-text="localOpenBreached.changeText"
            :has-change="localOpenTotal.hasChange"
            :is-positive="localOpenBreached.isPositive"
            :is-good-change="localOpenBreached.isGoodChange"
        />

        <MetricCard
            title="Backlog Growth"
            :value="localOpenGrowth.value"
            :change-text="localOpenGrowth.changeText"
            :has-change="localOpenTotal.hasChange"
            :is-positive="localOpenGrowth.isPositive"
            :is-good-change="localOpenGrowth.isGoodChange"
        />

        <MetricCard
            title="Completion Rate"
            :value="localCompletionRatePerHour.value"
            :change-text="localCompletionRatePerHour.changeText"
            :has-change="false"
        />
    </div>
</template>

<script setup lang="ts">
import MetricCard from '@/pages/OperationsInsights/components/MetricCard.vue';
import { BacklogSummariesComponentData } from '@/pages/OperationsInsights/composables/transformations/tfBLSummariesData';
import { computed } from 'vue';

interface Props {
  backlogSummariesData: BacklogSummariesComponentData;
}

const props = withDefaults(defineProps<Props>(), {});
const defaultSummaryObj = {
    value: 0, changeText: '', hasChange: false, isPositive: false, isGoodChange: false
};

const localOpenTotal = computed(() => {
    return props.backlogSummariesData?.openBacklogTotalSM ?? defaultSummaryObj;
});

const localOpenAtRisk = computed(() => {
    return props.backlogSummariesData?.openBacklogAtRiskSM ?? defaultSummaryObj;
});

const localOpenBreached = computed(() => {
    return props.backlogSummariesData?.openBacklogBreachedSM ?? defaultSummaryObj;
});

const localOpenGrowth = computed(() => {
    return props.backlogSummariesData?.openBacklogGrowthSM ?? defaultSummaryObj;
});

const localCompletionRatePerHour = computed(() => {
    return props.backlogSummariesData?.completedBacklogRateSM ?? defaultSummaryObj;
});

</script>

<style scoped lang="scss">
@use '../styles/metric-card.scss';
</style>